import BlogArticle from './BlogArticle';

export default BlogArticle;
